/* ==========================================================================
   SHOP CHIC · Lógica de páginas de producto
   - Selector de variantes (precio, stock, URL, imagen)
   - Galería con swipe, miniaturas, zoom y video con transparencia
   - Agregar al carrito por AJAX + "Comprar ahora"
   - Barra fija de compra, cuenta regresiva de envío y fechas de entrega
   ========================================================================== */
(function () {
  'use strict';
  if (window.ScProductInit) return;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Utilidades ---------- */
  function qs(sel, el) { return (el || document).querySelector(sel); }
  function qsa(sel, el) { return Array.prototype.slice.call((el || document).querySelectorAll(sel)); }

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = Number(cents) || 0;
    format = format || '${{amount}}';
    function fmt(n, dec, th, dc) {
      th = th === undefined ? ',' : th; dc = dc === undefined ? '.' : dc;
      var parts = (n / 100).toFixed(dec).split('.');
      parts[0] = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + th);
      return parts.join(dc);
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return fmt(cents, 0);
        case 'amount_with_comma_separator': return fmt(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return fmt(cents, 2, "'", '.');
        default: return fmt(cents, 2);
      }
    });
  }

  function addBusinessDays(date, days) {
    var d = new Date(date.getTime());
    while (days > 0) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) days--; }
    return d;
  }
  var dateFmt;
  try { dateFmt = new Intl.DateTimeFormat('es-MX', { weekday: 'short', day: 'numeric', month: 'short' }); } catch (e) { dateFmt = null; }
  function fmtDate(d) { return dateFmt ? dateFmt.format(d).replace(/\./g, '') : d.toDateString(); }

  function refreshCartCount() {
    return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        qsa('.cart-count-bubble span[aria-hidden="true"], [data-sc-cart-count]').forEach(function (el) { el.textContent = c.item_count; if (el.dataset) el.dataset.count = c.item_count; });
        var bubble = qs('#cart-icon-bubble');
        if (bubble && !qs('.cart-count-bubble', bubble) && c.item_count > 0) {
          bubble.insertAdjacentHTML('beforeend', '<div class="cart-count-bubble"><span aria-hidden="true">' + c.item_count + '</span></div>');
        }
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: c }));
        return c;
      }).catch(function () {});
  }

  /* ---------- Video con transparencia (MP4 apilado color/alfa + WebGL) ---------- */
  function AlphaVideo(wrap) { this.wrap = wrap; this.canvas = qs('canvas', wrap); this.video = qs('video', wrap); this.started = false; this.failed = false; }
  AlphaVideo.prototype.fail = function () { this.failed = true; this.wrap.classList.remove('is-live'); try { this.video.pause(); } catch (e) {} };
  AlphaVideo.prototype.init = function () {
    if (this.started || this.failed || reduce) return; this.started = true;
    var self = this, c = this.canvas, v = this.video;
    var gl = c.getContext('webgl', { premultipliedAlpha: true, alpha: true, antialias: false });
    if (!gl) return this.fail();
    var vs = 'attribute vec2 p;varying vec2 uv;void main(){uv=vec2((p.x+1.)*.5,1.-(p.y+1.)*.5);gl_Position=vec4(p,0.,1.);}';
    var fs = 'precision mediump float;uniform sampler2D t;varying vec2 uv;void main(){float y=min(uv.y*.5,.4992);vec3 col=texture2D(t,vec2(uv.x,y)).rgb;float a=texture2D(t,vec2(uv.x,.5008+uv.y*.4992)).r;a=smoothstep(.04,.96,a);gl_FragColor=vec4(col*a,a);}';
    function sh(type, src) { var s = gl.createShader(type); gl.shaderSource(s, src); gl.compileShader(s); return s; }
    var pr = gl.createProgram(); gl.attachShader(pr, sh(gl.VERTEX_SHADER, vs)); gl.attachShader(pr, sh(gl.FRAGMENT_SHADER, fs)); gl.linkProgram(pr);
    if (!gl.getProgramParameter(pr, gl.LINK_STATUS)) return this.fail();
    gl.useProgram(pr);
    gl.bindBuffer(gl.ARRAY_BUFFER, gl.createBuffer());
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 1, -1, -1, 1, 1, 1]), gl.STATIC_DRAW);
    var loc = gl.getAttribLocation(pr, 'p'); gl.enableVertexAttribArray(loc); gl.vertexAttribPointer(loc, 2, gl.FLOAT, false, 0, 0);
    gl.bindTexture(gl.TEXTURE_2D, gl.createTexture());
    [gl.TEXTURE_WRAP_S, gl.TEXTURE_WRAP_T].forEach(function (k) { gl.texParameteri(gl.TEXTURE_2D, k, gl.CLAMP_TO_EDGE); });
    [gl.TEXTURE_MIN_FILTER, gl.TEXTURE_MAG_FILTER].forEach(function (k) { gl.texParameteri(gl.TEXTURE_2D, k, gl.LINEAR); });
    gl.clearColor(0, 0, 0, 0);
    var hasRVFC = 'requestVideoFrameCallback' in v;
    function draw() {
      if (self.failed) return;
      if (v.readyState >= 2) {
        try { gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, v); } catch (e) { return self.fail(); }
        gl.viewport(0, 0, c.width, c.height); gl.clear(gl.COLOR_BUFFER_BIT); gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
        self.wrap.classList.add('is-live');
      }
      hasRVFC ? v.requestVideoFrameCallback(draw) : requestAnimationFrame(draw);
    }
    v.addEventListener('error', function () { self.fail(); });
    v.src = v.dataset.src; v.muted = true; v.loop = true;
    var p = v.play(); if (p && p.catch) p.catch(function () {});
    hasRVFC ? v.requestVideoFrameCallback(draw) : requestAnimationFrame(draw);
  };
  AlphaVideo.prototype.play = function () { if (!this.started) return this.init(); if (!this.failed) { var p = this.video.play(); if (p && p.catch) p.catch(function () {}); } };
  AlphaVideo.prototype.pause = function () { if (this.started) try { this.video.pause(); } catch (e) {} };

  /* ---------- Producto ---------- */
  function ScProduct(root) {
    this.root = root;
    root.dataset.scReady = '1';
    root.classList.add('sc-js');
    try { this.data = JSON.parse(qs('[data-sc-json]', root).textContent); } catch (e) { this.data = { variants: [] }; }
    this.form = qs('form[data-sc-form]', root);
    this.idInput = this.form ? qs('input[name="id"]', this.form) : null;
    this.initGallery();
    this.initVariants();
    this.initQty();
    this.initForm();
    this.initSticky();
    this.initShipping();
    this.initAddButtons();
    this.initReveal();
  }

  ScProduct.prototype.currentVariant = function () {
    var id = this.idInput ? Number(this.idInput.value) : 0;
    for (var i = 0; i < this.data.variants.length; i++) if (this.data.variants[i].id === id) return this.data.variants[i];
    return this.data.variants[0];
  };

  /* Galería */
  ScProduct.prototype.initGallery = function () {
    var self = this, root = this.root;
    this.track = qs('[data-sc-track]', root);
    if (!this.track) return;
    this.slides = qsa('[data-sc-slide]', root);
    this.thumbs = qsa('[data-sc-thumb]', root);
    this.dots = qsa('[data-sc-dots] i', root);
    this.alphas = qsa('[data-sc-alpha]', root).map(function (el) { var a = new AlphaVideo(el); el._alpha = a; return a; });
    this.index = 0;
    var ticking = false;
    this.track.addEventListener('scroll', function () {
      if (ticking) return; ticking = true;
      requestAnimationFrame(function () { ticking = false; var i = Math.round(self.track.scrollLeft / self.track.clientWidth); if (i !== self.index) self.setActive(i, false); });
    }, { passive: true });
    this.thumbs.forEach(function (t, i) { t.addEventListener('click', function () { self.goTo(i); }); });
    var prev = qs('[data-sc-prev]', root), next = qs('[data-sc-next]', root);
    if (prev) prev.addEventListener('click', function () { self.goTo(self.index - 1); });
    if (next) next.addEventListener('click', function () { self.goTo(self.index + 1); });
    /* Zoom con el cursor en escritorio */
    if (window.matchMedia('(hover:hover)').matches) {
      qsa('.sc-gal__slide--zoom', root).forEach(function (s) {
        var img = qs('img', s);
        s.addEventListener('click', function () { s.classList.toggle('is-zoom'); if (!s.classList.contains('is-zoom')) img.style.transformOrigin = ''; });
        s.addEventListener('mousemove', function (e) { if (!s.classList.contains('is-zoom')) return; var r = s.getBoundingClientRect(); img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%'; });
        s.addEventListener('mouseleave', function () { s.classList.remove('is-zoom'); img.style.transformOrigin = ''; });
      });
    }
    this.setActive(0, false);
  };
  ScProduct.prototype.goTo = function (i) {
    if (!this.slides || !this.slides.length) return;
    i = (i + this.slides.length) % this.slides.length;
    this.track.scrollTo({ left: i * this.track.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
    this.setActive(i, true);
  };
  ScProduct.prototype.setActive = function (i, fromClick) {
    this.index = i;
    this.thumbs.forEach(function (t, k) { t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
    this.dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
    var active = this.thumbs[i];
    if (active && fromClick && active.scrollIntoView) { var box = active.parentNode; box.scrollTo({ top: active.offsetTop - box.clientHeight / 2 + active.clientHeight / 2, behavior: 'smooth' }); }
    this.slides.forEach(function (s, k) {
      var v = qs('video:not([data-src])', s);
      if (v) { if (k === i) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else v.pause(); }
      var a = qs('[data-sc-alpha]', s); if (a && a._alpha) { k === i ? a._alpha.play() : a._alpha.pause(); }
    });
  };
  ScProduct.prototype.showMedia = function (mediaId) {
    if (!mediaId || !this.slides) return;
    for (var i = 0; i < this.slides.length; i++) if (Number(this.slides[i].dataset.mediaId) === mediaId) return this.goTo(i);
  };

  /* Variantes */
  ScProduct.prototype.initVariants = function () {
    var self = this;
    this.fieldsets = qsa('[data-sc-option]', this.root);
    if (!this.fieldsets.length) { this.updateUI(this.currentVariant(), false); return; }
    this.fieldsets.forEach(function (fs) { fs.addEventListener('change', function () { self.onOptionChange(); }); });
    this.markAvailability();
    this.updateUI(this.currentVariant(), false);
  };
  ScProduct.prototype.selectedOptions = function () {
    return this.fieldsets.map(function (fs) { var c = qs('input:checked', fs); return c ? c.value : null; });
  };
  ScProduct.prototype.onOptionChange = function () {
    var sel = this.selectedOptions();
    var v = this.data.variants.filter(function (v) { return v.options.every(function (o, i) { return o === sel[i]; }); })[0];
    this.fieldsets.forEach(function (fs, i) { var l = qs('[data-sc-selected]', fs); if (l) l.textContent = sel[i]; });
    this.markAvailability();
    this.updateUI(v, true);
  };
  ScProduct.prototype.markAvailability = function () {
    var self = this, sel = this.selectedOptions();
    this.fieldsets.forEach(function (fs, idx) {
      qsa('input', fs).forEach(function (inp) {
        var test = sel.slice(); test[idx] = inp.value;
        var ok = self.data.variants.some(function (v) { return v.available && v.options.every(function (o, i) { return o === test[i]; }); });
        var lab = inp.nextElementSibling; if (lab) lab.classList.toggle('is-unavailable', !ok);
      });
    });
  };
  ScProduct.prototype.updateUI = function (v, pushUrl) {
    var root = this.root, fmt = this.data.moneyFormat;
    var atcs = qsa('[data-sc-atc]', root), buys = qsa('[data-sc-buynow]', root);
    if (!v) {
      if (!this.data.variants.length) return; /* sin datos: se respeta el estado renderizado por Liquid */
      atcs.forEach(function (b) { b.disabled = true; var t = qs('[data-sc-atc-text]', b); if (t) t.textContent = 'No disponible'; });
      buys.forEach(function (b) { b.disabled = true; });
      return;
    }
    if (this.idInput) this.idInput.value = v.id;
    qsa('[data-sc-price]', root).forEach(function (el) { el.textContent = formatMoney(v.price, fmt); });
    var onSale = v.compare_at_price && v.compare_at_price > v.price;
    qsa('[data-sc-compare]', root).forEach(function (el) { el.textContent = onSale ? formatMoney(v.compare_at_price, fmt) : ''; el.hidden = !onSale; });
    qsa('[data-sc-save]', root).forEach(function (el) {
      el.hidden = !onSale;
      if (onSale) el.textContent = (el.dataset.scSave === 'amount' ? 'Ahorras ' + formatMoney(v.compare_at_price - v.price, fmt) : '-' + Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%');
    });
    atcs.forEach(function (b) { b.disabled = !v.available; var t = qs('[data-sc-atc-text]', b); if (t) t.textContent = v.available ? (b.dataset.label || 'Agregar al carrito') : 'Agotado'; });
    buys.forEach(function (b) { b.disabled = !v.available; });
    this.updateStock(v);
    if (pushUrl) {
      if (v.media_id) this.showMedia(v.media_id);
      try { var u = new URL(window.location.href); u.searchParams.set('variant', v.id); window.history.replaceState({}, '', u.toString()); } catch (e) {}
    }
  };
  ScProduct.prototype.updateStock = function (v) {
    var box = qs('[data-sc-stock]', this.root); if (!box) return;
    var label = qs('[data-sc-stock-label]', box), bar = qs('[data-sc-stock-bar]', box), low = this.data.lowStock || 0;
    box.classList.remove('is-low', 'is-out');
    if (!v.available) { box.classList.add('is-out'); label.textContent = 'Agotado por el momento'; if (bar) bar.parentNode.hidden = true; return; }
    if (v.managed && v.policy === 'deny' && v.inv > 0 && v.inv <= low) {
      box.classList.add('is-low');
      label.innerHTML = '¡Date prisa! Solo quedan <b>' + v.inv + '</b> ' + (v.inv === 1 ? 'pieza' : 'piezas');
      if (bar) { bar.parentNode.hidden = false; bar.style.width = Math.max(8, Math.min(100, v.inv / low * 100)) + '%'; }
    } else {
      label.textContent = box.dataset.inStock || 'En existencia, listo para enviar';
      if (bar) bar.parentNode.hidden = true;
    }
  };

  /* Cantidad */
  ScProduct.prototype.initQty = function () {
    qsa('[data-sc-qty]', this.root).forEach(function (q) {
      var inp = qs('input', q);
      qsa('button', q).forEach(function (b) {
        b.addEventListener('click', function () {
          var n = Math.max(1, (parseInt(inp.value, 10) || 1) + (b.dataset.step === '-' ? -1 : 1));
          inp.value = n; inp.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  };

  /* Toast */
  ScProduct.prototype.toast = function (title, msg, img) {
    var t = qs('[data-sc-toast]', this.root); if (!t) return;
    qs('[data-sc-toast-title]', t).textContent = title;
    qs('[data-sc-toast-msg]', t).textContent = msg;
    if (img) qs('[data-sc-toast-img]', t).src = img;
    t.classList.add('is-show'); clearTimeout(this._tt);
    this._tt = setTimeout(function () { t.classList.remove('is-show'); }, 6000);
  };

  /* Formulario de compra */
  ScProduct.prototype.initForm = function () {
    var self = this, form = this.form; if (!form) return;
    var buyNow = false;
    qsa('[data-sc-buynow]', this.root).forEach(function (b) { b.addEventListener('click', function () { buyNow = true; if (form.requestSubmit) form.requestSubmit(); else form.dispatchEvent(new Event('submit', { cancelable: true })); }); });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var err = qs('[data-sc-error]', self.root); if (err) err.textContent = '';
      var btn = buyNow ? qs('[data-sc-buynow]', self.root) : qs('[data-sc-atc]', form);
      if (btn) btn.setAttribute('aria-busy', 'true');
      var goCheckout = buyNow || self.data.after === 'checkout';
      buyNow = false;
      fetch(self.data.cartAddUrl, { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: new FormData(form) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok || j.status) throw j; return j; }); })
        .then(function (item) {
          if (goCheckout) { window.location.href = self.data.checkoutUrl; return; }
          if (self.data.after === 'cart') { window.location.href = self.data.cartUrl; return; }
          refreshCartCount();
          self.toast('¡Listo! Se agregó a tu carrito', item.product_title + (item.variant_title ? ' · ' + item.variant_title : ''), item.image);
        })
        .catch(function (j) { var m = (j && (j.description || j.message)) || 'No se pudo agregar. Intenta de nuevo.'; if (err) err.textContent = m; self.toast('Ups…', m); })
        .finally(function () { if (btn) btn.removeAttribute('aria-busy'); });
    });
  };

  /* Botones de agregar sueltos (venta cruzada) */
  ScProduct.prototype.initAddButtons = function () {
    var self = this;
    qsa('[data-sc-add]', this.root).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var ids = btn.dataset.scAdd.split(',').filter(Boolean);
        btn.setAttribute('aria-busy', 'true');
        fetch(self.data.cartAddUrl, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: ids.map(function (id) { return { id: Number(id), quantity: 1 }; }) }) })
          .then(function (r) { return r.json().then(function (j) { if (!r.ok || j.status) throw j; return j; }); })
          .then(function () { refreshCartCount(); self.toast('¡Agregado al carrito!', btn.dataset.scTitle || '', btn.dataset.scImg); })
          .catch(function (j) { self.toast('Ups…', (j && j.description) || 'No se pudo agregar.'); })
          .finally(function () { btn.removeAttribute('aria-busy'); });
      });
    });
  };

  /* Barra fija */
  ScProduct.prototype.initSticky = function () {
    var bar = qs('[data-sc-sticky]', this.root), target = qs('[data-sc-buy]', this.root), self = this;
    if (!bar || !target || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (en) {
      var e = en[0]; bar.classList.toggle('is-show', !e.isIntersecting && e.boundingClientRect.top < 0);
    }).observe(target);
    var sbtn = qs('[data-sc-sticky-btn]', bar);
    if (sbtn) sbtn.addEventListener('click', function () {
      if (self.fieldsets && self.fieldsets.length > 1) { target.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
      var atc = qs('[data-sc-atc]', self.form); if (atc && !atc.disabled) atc.click();
    });
  };

  /* Envío: cuenta regresiva y fechas estimadas */
  ScProduct.prototype.initShipping = function () {
    var root = this.root, s = this.data.ship; if (!s) return;
    var timer = qs('[data-sc-ship-timer]', root), line = qs('[data-sc-ship-line]', root);
    function tick() {
      var now = new Date(), day = now.getDay(), cut = new Date(now); cut.setHours(s.cutoff, 0, 0, 0);
      var businessDay = day !== 0 && day !== 6;
      var shipDate = (businessDay && now < cut) ? now : addBusinessDays(now, 1);
      if (line) {
        if (businessDay && now < cut) {
          var ms = cut - now, h = Math.floor(ms / 36e5), m = Math.floor(ms % 36e5 / 6e4), sec = Math.floor(ms % 6e4 / 1e3);
          if (timer) timer.textContent = (h ? h + ' h ' : '') + m + ' min ' + ('0' + sec).slice(-2) + ' s';
          line.hidden = false;
        } else { line.hidden = true; }
      }
      var a = addBusinessDays(shipDate, s.min), b = addBusinessDays(shipDate, s.max);
      qsa('[data-sc-eta-order]', root).forEach(function (el) { el.textContent = fmtDate(now); });
      qsa('[data-sc-eta-ship]', root).forEach(function (el) { el.textContent = fmtDate(shipDate); });
      qsa('[data-sc-eta-deliver]', root).forEach(function (el) { el.textContent = fmtDate(a) + ' – ' + fmtDate(b); });
    }
    tick(); setInterval(tick, 1000);
  };

  /* Aparición al hacer scroll */
  ScProduct.prototype.initReveal = function () {
    var els = qsa('.sc-reveal', this.root);
    if (!('IntersectionObserver' in window) || reduce) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (en) { en.forEach(function (e) { if (e.isIntersecting || e.boundingClientRect.top < 0) { e.target.classList.add('is-in'); io.unobserve(e.target); } }); }, { threshold: .12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (e) { io.observe(e); });
  };

  function init() { qsa('[data-sc-product]:not([data-sc-ready])').forEach(function (r) { new ScProduct(r); }); }
  window.ScProductInit = init;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
